import React from "react";
import { WidgetTeamScheduleContentList } from "./WidgetTeamScheduleContentList";
import { graphql, useFragment } from "react-relay";
import { WidgetTeamScheduleContentWeekly_WidgetTeamScheduleContentWeekly$key } from "./__generated__/WidgetTeamScheduleContentWeekly_WidgetTeamScheduleContentWeekly.graphql";
import { WidgetTeamScheduleContentBaseProps } from "./WidgetTeamScheduleContentBaseProps";
import { AHSeparator, Box } from "arkh";
import { WidgetTeamScheduleContentSectionHeader } from "./WidgetTeamScheduleContentSectionHeader";

export function WidgetTeamScheduleContentWeekly(
  props: WidgetTeamScheduleContentBaseProps & {
    content: WidgetTeamScheduleContentWeekly_WidgetTeamScheduleContentWeekly$key;
  }
) {
  const content = useFragment(
    graphql`
      fragment WidgetTeamScheduleContentWeekly_WidgetTeamScheduleContentWeekly on WidgetTeamScheduleContentWeekly {
        weeklyTeamSchedule {
          ...WidgetTeamScheduleContentList_teamSchedule
          ...WidgetTeamScheduleContentSectionHeader_teamSchedule
        }
      }
    `,
    props.content
  );

  return (
    <Box style={{ flex: 1 }}>
      <WidgetTeamScheduleContentSectionHeader
        teamSchedule={content.weeklyTeamSchedule}
        tint={props.tint}
      />
      <AHSeparator spaceTop="xsmall" />
      <WidgetTeamScheduleContentList
        teamId={props.teamId}
        isDarkTint={props.isDarkTint}
        interactive={props.interactive}
        tint={props.tint}
        size={props.size}
        teamSchedule={content.weeklyTeamSchedule}
        onPressRoutineOccasion={props.onPressRoutineOccasion}
        mode={props.mode}
        now={props.now}
        idiom={props.idiom}
        onScroll={props.onScroll}
        isFocused={props.isFocused}
      />
    </Box>
  );
}
